module.exports = __webpack_public_path__ + "static/media/perfil-corporativo.d7dd5521.jpg";